import axios from "axios";

import { API_BASE } from "./routes";

const axiosInstance = axios.create({
  baseURL: API_BASE,
});

export const axiosInstanceForUploadFile = axios.create();

export default axiosInstance;

export const updateToken = (token: string) => {
  // console.log('updateToken:', token);
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  // console.log(' updateToken Axios token:', axiosInstance.defaults.headers.common.Authorization);
};

export const removeToken = () => {
  axiosInstance.defaults.headers.common = {};
};
